<template>
  <Row>
    <Col span="24">
      <!-- <div
        style="
          display: flex;
          width: 100%;
          background: linear-gradient(to bottom, #ffffff, #dddddd);
          margin-bottom: 20px;
        "
      >
        <img
          style="background: #02a0e7"
          src="../../../static/img/Buy/icon-home.png"
          alt="暂无照片"
        />
        <Breadcrumb style="margin: 10px 0 0 30px" separator=">">
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem to="/home/News">新闻资讯</BreadcrumbItem>
          <BreadcrumbItem>行业新闻</BreadcrumbItem>
        </Breadcrumb>
      </div> -->
      <div class="res_div">
        <p class="res_div_p">{{ title }}</p>
        <div class="res_div_div"></div>
        <div style="text-align: center">
          <span class="news_ul_div_div02_sp">
            发布时间：2020-11-19
          </span>
        </div>
        <div class="div_img01" v-for="(item, index) in img" :key="index">
          <span
            v-if="item.sp !== ''"
            :src="item.sp"
            style="
              font-size: 17px;
              font-weight: bold;
              color: #70a9f8;
              line-height: 34px;
            "
            >{{ item.sp }}</span
          >
          <p class="font_div">{{ item.p }}</p>
          <img v-if="item.imgUrl !== ''" :src="item.imgUrl" alt="暂无照片" />
          <img
            v-if="item.imgUrl02 !== ''"
            :src="item.imgUrl02"
            alt="暂无照片"
          />
          <img
            v-if="item.imgUrl03 !== ''"
            :src="item.imgUrl03"
            alt="暂无照片"
          />
        </div>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      title: "南秀科技开启建筑施工数据采集数字化应用新赛道",
      img: [
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree01.jpg",
          imgUrl02: "",
          imgUrl03: "",
          sp: "",
          p:
            "在建筑施工过程中，为了确保工程施工质量，建筑企业会产生大量测量数据，但是由于目前建筑施工过程中信息化手段相对不足，导致项目数据信息采集不足、一线工作人员效率不高、以及其它智能设备价格贵、不成体系等问题，也是大家常说的“头痛、手痛、脚痛、心痛”。针对这一市场痛点，南秀科技联合中国建筑第五工程局研发了由硬件设备（智能靠尺、智能角测仪、智能回弹仪、智能测距仪等）、移动智能终端、数据服务后台、网页前端四位一体的实测实量管理系统。\n" +
            "2020年11月15日，南秀科技在智慧岛大厦组织了“实测实量管理系统及工法三维虚拟仿真”专题研讨会。参会嘉宾有：河南省科技厅创业中心主任赵寅星、河南省科技厅创业中心总工程师訾伟旗、省建科院副院长刘付林、河南省建科院副总工冯勇、河南省计量院书记陈传岭、郑州市轨道办副主任顾建党、中建七局副总工鲁班奖评委王五奇、河南省二建副董事长牛小昌、中建七局地产公司经理靳琳、郑州一建信息中心主任张继永、智慧岛大厦运营部负责人赵欣、" +
            "中国建筑第五工程局河南公司技术部经理万东波、南秀科技创始人王英豪。中国建筑第五工程局河南公司技术部经理万东波和南秀科技创始人王英豪分别对实测实量管理系统和工法三维虚拟仿真产品进行了介绍，河南省科技厅创业中心主任赵寅星主持了本次研讨会。",
        },
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree02.jpg",
          imgUrl02: "../../../static/img/News/NewsThree/NewsThree03.jpg",
          imgUrl03: "../../../static/img/News/NewsThree/NewsThree04.jpg",
          sp: "实测实量管理系统产品介绍",
          p: "",
        },
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree05.jpg",
          imgUrl02: "../../../static/img/News/NewsThree/NewsThree06.jpg",
          imgUrl03: "../../../static/img/News/NewsThree/NewsThree07.jpg",
          sp: "智能靠尺演示",
          p: "",
        },
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree08.jpg",
          imgUrl02: "../../../static/img/News/NewsThree/NewsThree09.jpg",
          imgUrl03: "",
          sp: "智能回弹仪展示",
          p: "",
        },
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree10.jpg",
          imgUrl02: "",
          imgUrl03: "",
          sp: "游标卡尺展示",
          p: "",
        },
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree11.jpg",
          imgUrl02: "",
          imgUrl03: "",
          sp: "工法三维虚拟仿真产品介绍 ",
          p:
            "为确保工程的施工质量，国家也提出了样板先行，样板引路的要求，工法样板的重要性日趋显现。因此，南秀科技严格依照国家规范，利用虚拟现实技术设计制作了工法三维虚拟仿真产品，使得施工人员只需要通过手指触控屏幕便可对相应的样板进行缩放、旋转、移动和分解演示等操作，随时随地方便快捷地查看施工细部节点的施工工艺。" +
            "与会嘉宾表示很高兴看到虚拟现实在建筑领域中的应用，认为这一平台不仅可以降低项目样板区建设的费用，还可以解决项目结束后样板废置的问题。",
        },
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree12.jpg",
          imgUrl02: "../../../static/img/News/NewsThree/NewsThree13.jpg",
          imgUrl03: "",
          sp: "互动台党建产品介绍 ",
          p:
            "该设备通过令牌或触卡在操作台进行操作，操作台屏幕识别操作手势从而做出反应。可用于展馆展会，多人互动，产品营销现场沟通。讲解便捷直观观看反复推演效果展示。多人会议直接数据展示转移，协同联动工作效率高。比如在项目施工中可操控令牌进行施工场地各个部分的布置安排，全方位把控和展示项目详细信息和规划，" +
            "多角度多视角进行施工现场浏览，减少安全隐患。通过对项目中热点部分进行专门数据展示，更加直观。游走到不同区域可进行丰富的语音和视频讲解规划等。",
        },
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree14.jpg",
          imgUrl02: "../../../static/img/News/NewsThree/NewsThree15.jpg",
          imgUrl03: "../../../static/img/News/NewsThree/NewsThree16.jpg",
          sp: "领导专家提问 ",
          p: "",
        },
        {
          imgUrl: "",
          imgUrl02: "",
          imgUrl03: "",
          sp: "会议总结 ",
          p:
            "通过本次研讨会，十几名领导专家对实测实量管理系统及工法三维虚拟仿真系统的核心特征、保护与开发等进行了深入探讨，对相关的实测实量的相关产品及工法三维虚拟仿真系统给予了高度肯定，同时给出了很多专业性的宝贵建议。在此南秀科技的全体人员对各位专家的莅临和指导表示衷心的感谢！南秀科技创始人表示今后我们将深耕项目，" +
            "秉承匠心，坚守初心，进一步优化实测实量管理系统，继续推广虚拟现实在建筑领域中的应用，为我国的建筑行业提供更好的解决方案！",
        },
        {
          imgUrl: "../../../static/img/News/NewsThree/NewsThree17.jpg",
          imgUrl02: "",
          imgUrl03: "",
          sp: "会议结束领导专家合影留念 ",
          p: "",
        },
      ],
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    getUnderStandMore() {
      this.$router.push({
        name: "AR",
      });
    },
  },
};
</script>

<style scoped>
.res_div img {
  width: 100%;
  margin: 10px 0;
}

.res_div_p {
  font-size: 30px;
  font-weight: bold;
  color: #000;
}

.font_div {
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
}

.res_div_div {
  border-bottom: 1px dashed #e1e1e1;
  margin: 10px 0;
}

.news_ul_div_div02_sp {
  font-size: 12px;
  color: #888;
  line-height: 30px;
}

.div_img01 img {
  width: 96%;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/News/NewsThree.vue